import React from 'react';
import { Box } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';

const LineChart = ({ data }) => {
  // Função para calcular se deve usar texto branco ou preto baseado na luminosidade da cor
  const getContrastColor = (hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  };

  // Transformar os dados para o formato que o Nivo espera
  const nivoData = [
    {
      id: 'Fee Fixo Monefica',
      color: '#121C42',
      data: data
        ? data.map((item, index) => ({
            x: `Ano ${index + 1}`,
            y: item.monefica,
          }))
        : [],
    },
    {
      id: 'Modelo Tradicional',
      color: '#FDA506',
      data: data
        ? data.map((item, index) => ({
            x: `Ano ${index + 1}`,
            y: item.traditional,
          }))
        : [],
    },
  ];

  const formatValue = (value) => `R$ ${value.toLocaleString('pt-BR')}`;

  return (
    <ResponsiveLine
      data={nivoData}
      margin={{ top: 20 }}
      axisLeft={false}
      enableGridX={false}
      enableGridY={false}
      colors={['#FDA506', '#121C42']}
      enablePoints={false}
      enableArea={true}
      areaOpacity={1}
      areaBlendMode="normal"
      areaBaselineValue={0}
      enableTouchCrosshair={true}
      useMesh={true}
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'top-left',
          direction: 'column',
          justify: false,
          translateX: 15,
          translateY: 4,
          itemsSpacing: 3,
          itemWidth: 100,
          itemHeight: 16,
          effects: [
            {
              on: 'hover',
              style: {
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
      // tooltip={({ point }) => (
      //   <Box
      //     sx={{
      //       background: 'white',
      //       padding: '9px 12px',
      //       border: '1px solid #ccc',
      //       borderRadius: '4px',
      //       boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      //     }}
      //   >
      //     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      //       <Box
      //         sx={{
      //           width: 12,
      //           height: 12,
      //           backgroundColor: point.serieColor,
      //           borderRadius: '50%',
      //         }}
      //       />
      //       <strong>{point.serieId}</strong>
      //     </Box>
      //     <div>
      //       {point.data.xFormatted}: {formatValue(point.data.yFormatted)}
      //     </div>
      //   </Box>
      // )}
    />
  );
};

export default LineChart;
